import { useQuery } from "react-query";
import { fetchSupplies } from "../queries/supplies.queries";
import { PaginatedFilter } from "../types/axios.types";

export const useSupplies = (page?: number, size?: number, search?: string, filters?: PaginatedFilter, sortBy?: string[]) => {
    const query = useQuery(['supplies', page, size, search, filters, sortBy], () => {
        try {
            return fetchSupplies(page, size, search, filters, sortBy);
        } catch (err) {
            return null;
        }
    });
    return query?.data;
};